// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-actively-exploited-vuln-report.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-actively-exploited-vuln-report',
  title:
    'Operate the CRA Art. 14 reporting clock for actively exploited vulnerabilities (24h / 72h / 14d)',
  description:
    'Confirm that the manufacturer has the operational capability to report actively exploited vulnerabilities in its products with digital elements to ENISA and the relevant CSIRT designated as coordinator under CRA Art. 14: an early warning notification within 24 hours of becoming aware (Art. 14(1)); a vulnerability notification within 72 hours that includes general information about the product, the nature of the vulnerability, and any corrective or mitigating measures (Art. 14(2)); and a final report no later than 14 days after a corrective or mitigating measure is available (Art. 14(2)). Reporting clocks are surfaced to the responder as deadlines, lateness is recorded with a justification, and submissions are evidenced. Review the reporting playbook, the contact register, and the historical submission log.',
  category: 'incidents',
  scfIds: ['SCF-INC-001', 'SCF-INC-006'],
  cadence: { frequency: '3m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Art. 14 reporting playbook is published' },
    { type: 'document-approved', description: 'Playbook has been approved' },
    { type: 'document-within-sla', description: 'Playbook review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
